export const macromoleculesFilesInputFormats = {
  ket: 'chemical/x-indigo-ket',
  mol: 'chemical/x-mdl-molfile',
  seq: {
    rna: 'chemical/x-rna-sequence',
    dna: 'chemical/x-dna-sequence',
    peptide: 'chemical/x-peptide-sequence',
    peptide3Letter: 'chemical/x-peptide-sequence-3-letter',
  },
  fasta: {
    rna: 'chemical/x-rna-fasta',
    dna: 'chemical/x-dna-fasta',
    peptide: 'chemical/x-peptide-fasta',
  },
  idt: 'chemical/x-idt',
  helm: 'chemical/x-helm',
};
